module.exports = __webpack_public_path__ + "img/2022_dodge-durango.933d24f5.png";